/**
 * Helper function that works like lodash's get()
 * Safely retrieves nested values from an object using a path string
 * @param {Object} obj - The object to query
 * @param {string|Array} path - The path to the property (e.g., 'a.b.c' or ['a', 'b', 'c'])
 * @param {*} defaultValue - The value to return if the path doesn't exist
 * @returns {*} The value at the path or the default value
 * 
 * @example
 * getByPath({ a: { b: { c: 1 } } }, 'a.b.c') // => 1
 * getByPath({ a: { b: { c: 1 } } }, 'a.b.d', 'default') // => 'default'
 * getByPath({ a: [{ b: 1 }] }, 'a[0].b') // => 1
 * getByPath(null, 'a.b', 'default') // => 'default'
 */
const getByPath = (obj, path, defaultValue = undefined) => {
  if (obj == null) return defaultValue

  const pathArray = Array.isArray(path)
    ? path
    : path.replace(/\[(\d+)\]/g, '.$1').split('.').filter(Boolean)

  let result = obj
  for (const key of pathArray) {
    if (result == null || typeof result !== 'object') {
      return defaultValue
    }
    result = result[key]
  }

  return result === undefined ? defaultValue : result
}

export default getByPath
